module.exports = __webpack_public_path__ + "static/media/heaterlux-5.8f5f2c07.jpg";